module.exports = __webpack_public_path__ + "static/media/notification.d0aeecd0.svg";